import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";

import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import loaderGif from "../../assets/img/loader.gif";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import fetcher from "../../api/swr_fetcher";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OrdersTab(props) {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const [value, setValue] = useState(0);
  const [tradeHistory, setTradeHistory] = useState(null);
  const [pendingHistory, setPendingHistory] = useState(null);
  const [orders, setOrders] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [penPage, setPenPage] = useState(0);

  const [hideOtherTrades, setHideOtherTrades] = useState(false);
  let selected_coin = useSelector((state) => state.trading.SELECTED_COIN);
  const [filterTradesBy, setFilterTradesBy] = useState(selected_coin);
  const [doubleClick, setDoubleClick] = useState(false);

  const token = useSelector((state) => state.trading.TOKEN);
  // const refreshOrders = useSelector(state => state.REFRESH_ORDER);
  // eslint-disable-next-line no-unused-vars

  const { refreshOrders, updateBalances, handleClickAlert, bannedTimeout } =
    useContext(CoinContext);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function loadMore() {
    if (tradeHistory) {
      if (page < tradeHistory.totalPages - 1) {
        setPage(page + 1);
      }
    }
  }

  function loadMorePending() {
    if (pendingHistory) {
      if (penPage < pendingHistory.totalPages - 1) {
        setPenPage(penPage + 1);
      }
    }
  }

  useEffect(() => {
    setFilterTradesBy(selected_coin);
  }, [selected_coin]);

  useEffect(() => {
    handleRefreshOrder();
    handlePendingOrders();
    // console.log("re-render orders!?");
  }, [refreshOrders, hideOtherTrades, filterTradesBy]);

  useEffect(() => {
    if (page > 0) {
      getMoreOrders();
      // console.log("Loading more orders");
    }
  }, [page]);

  useEffect(() => {
    if (penPage > 0) {
      getMorePendingOrders();
      // console.log("Loading more orders");
    }
  }, [penPage]);

  function handleRefreshOrder() {
    let url = hideOtherTrades
      ? `/v1/orders?status=FILLED,CANCELLED&sortBy=modifiedAt&direction=DESC&page=1&pageSize=20&searchId=${filterTradesBy}INR`
      : `/v1/orders?status=FILLED,CANCELLED&sortBy=modifiedAt&direction=DESC&page=1&pageSize=20`;
    if (token) {
      fetcher(url)
        .then((data) => {
          setTradeHistory(data);
          setOrders(data.content);

          console.log(url);
          // console.log(token);
          console.log("Getting/Refreshing orders", data);
        })
        .catch((err) => {
          setTradeHistory([]);
          console.error(err);
          // console.error(err);
        });
    }
  }

  function handlePendingOrders() {
    let url = hideOtherTrades
      ? `/v1/orders?status=PENDING&sortBy=modifiedAt&direction=DESC&page=1&pageSize=20&searchId=${filterTradesBy}INR`
      : `/v1/orders?status=PENDING&sortBy=modifiedAt&direction=DESC&page=1&pageSize=20`;
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(url)
        .then((data) => {
          setPendingHistory(data);
          setPendingOrders(data?.content || []);

          // console.log("Getting pending orders", data);
        })
        .catch((err) => {
          console.error(err);
          setPendingHistory(null);
          setPendingOrders([]);
          // console.error(err);
        });
    }
  }

  function getMoreOrders() {
    let url = hideOtherTrades
      ? `/v1/orders?status=FILLED,CANCELLED&sortBy=modifiedAt&direction=DESC&page=${
          page + 1
        }&pageSize=20&searchId=${filterTradesBy}INR`
      : `/v1/orders?status=FILLED,CANCELLED&sortBy=modifiedAt&direction=DESC&page=${
          page + 1
        }&pageSize=20`;

    if (token) {
      var bearer = "Bearer " + token;
      fetcher(url)
        .then((data) => {
          setTradeHistory(data);
          setOrders((prevOrders) => {
            return [...prevOrders, ...data.content];
          });
          // console.log("Getting more orders", data);
        })
        .catch((err) => {
          setTradeHistory([]);
          console.error(err);
          // console.error(err);
        });
    }
  }

  function getMorePendingOrders() {
    let url = hideOtherTrades
      ? `/v1/orders?status=PENDING&sortBy=modifiedAt&direction=DESC&page=${
          penPage + 1
        }&pageSize=20&searchId=${filterTradesBy}INR`
      : `/v1/orders?status=PENDING&sortBy=modifiedAt&direction=DESC&page=${
          penPage + 1
        }&pageSize=20`;
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(url)
        .then((data) => {
          setPendingHistory(data);
          setPendingOrders((prevOrders) => {
            return [...prevOrders, ...data.content];
          });
          // console.log("Getting more orders", data);
        })
        .catch((err) => {
          setPendingHistory(null);
          console.error(err);
          // console.error(err);
        });
    }
  }

  function handleCancelOrder(orderId) {
    if (token) {
      fetcher(`/v1/orders/${orderId}`, { method: "DELETE" })
        .then((data) => {
          if (data.status === "CANCELLED") {
            handleRefreshOrder();
            handlePendingOrders();
            updateBalances(data.modifiedAt);
            handleClickAlert("success", "Order cancelled successfully");
            setDoubleClick(false);
          } else {
            handleClickAlert("error", "Failed to cancel order");
            setDoubleClick(false);
          }
          // console.log("Order cancelled:", data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
    }
  }

  return (
    <div className={classes.root}>
      <AppBar position="sticky" className={classes.appBar}>
        {token ? (
          <CustomTabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            style={{ minHeight: "40px", height: "40px" }}
          >
            <StyledTab
              label="My Trade History"
              {...a11yProps(0)}
              style={{ paddingBottom: "14px", fontSize: "10px" }}
            />
            <StyledTab
              label="My Pending Orders"
              {...a11yProps(1)}
              style={{ paddingBottom: "14px", fontSize: "10px" }}
            />
          </CustomTabs>
        ) : (
          <CustomTabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            style={{ minHeight: "40px", height: "40px" }}
          >
            <StyledTab
              label="My Trade History"
              {...a11yProps(0)}
              disabled
              style={{ paddingBottom: "14px", fontSize: "10px" }}
            />
            <StyledTab
              label="My Pending Orders"
              {...a11yProps(1)}
              disabled
              style={{ paddingBottom: "14px", fontSize: "10px" }}
            />
          </CustomTabs>
        )}
      </AppBar>

      <FormControlLabel
        style={{
          width: "100%",
          height: "2rem",
          textAlign: "center",
          paddingRight: "10px",
          fontSize: "10px",
          justifyContent: "center",
        }}
        label={
          <span style={{ fontSize: "0.9rem" }}>Show only {filterTradesBy}</span>
        }
        labelPlacement="start"
        control={
          <Switch
            onChange={(e, c) => setHideOtherTrades(c)}
            color="primary"
            label="Hide"
          />
        }
      />

      <TabPanel value={value} index={0} className={classes.customTabContainer}>
        {token ? (
          <>
            {tradeHistory ? (
              tradeHistory.totalElements === 0 ? (
                <p
                  style={{
                    fontSize: "14px",
                    color:
                      theme.palette.type === "dark" ? "#C6C6CA" : "#808080",
                    fontWeight: "bold",
                    paddingTop: "15px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    paddingBottom: "15px",
                  }}
                >
                  Your trade history will appear here.
                </p>
              ) : (
                <>
                  <div className={classes.ptitleContainer}>
                    <div style={{ width: "66.66%" }}>
                      <p className={classes.ptitle}>Total</p>
                    </div>
                    <div style={{ width: "66.66%" }}>
                      <p
                        className={classes.ptitle}
                        style={{ textAlign: "center" }}
                      >
                        Price
                      </p>
                    </div>
                    <Grid container justify="flex-end">
                      <Grid item>
                        <p
                          className={classes.ptitle}
                          style={{ textAlign: "right" }}
                        >
                          Quantity
                        </p>
                      </Grid>
                    </Grid>
                  </div>
                  <div style={{ maxHeight: "80vh", overflow: "scroll" }}>
                    {orders
                      .filter((order) =>
                        !hideOtherTrades
                          ? true
                          : order.symbol.slice(0, -3) == filterTradesBy,
                      )
                      .map((order) =>
                        order.status === "FILLED" ||
                        order.status === "CANCELLED" ? (
                          <div
                            key={order.orderId}
                            className={classes.listItemStyle}
                            style={
                              theme.palette.type === "dark"
                                ? order.status === "CANCELLED" ||
                                  order.status === "FAILED"
                                  ? { background: "#4F525A" }
                                  : {
                                      background:
                                        order.side === "BUY"
                                          ? "#204847"
                                          : "#4C323B",
                                    }
                                : order.status === "CANCELLED" ||
                                  order.status === "FAILED"
                                ? { background: "#EAEAEA" }
                                : {
                                    background:
                                      order.side === "BUY"
                                        ? "#D2F5EB"
                                        : "#FCDFDF",
                                  }
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                overflow: "hidden",
                                flexDirection: "row",
                                flexWrap: "nowrap",
                              }}
                            >
                              <p
                                style={{
                                  marginTop: 0,
                                  color:
                                    order.side === "BUY"
                                      ? "#3AC4AB"
                                      : "#DE565E",
                                  fontWeight: "bold",
                                  width: "66.66%",
                                  textDecoration:
                                    order.status === "CANCELLED"
                                      ? "line-through"
                                      : null,
                                }}
                                className={classes.psubtitle}
                              >
                                {order.side === "BUY" ? "Buy" : "Sell"}{" "}
                                {order.marketType === "LIMIT" ? "Pro" : "Inst"}
                              </p>
                              <div style={{ width: "66.66%" }}>
                                <p
                                  className={classes.psubtitle}
                                  style={{ textAlign: "center" }} //right
                                >
                                  {order.symbol.slice(0, -3)}
                                  <span className={classes.baseCoin}>/INR</span>
                                </p>
                              </div>
                              {/* Date */}
                              <Grid container justify="flex-end">
                                <Grid item>
                                  <span
                                    style={{
                                      color:
                                        theme.palette.type === "dark"
                                          ? "#cdcdcd"
                                          : "#707384",
                                      fontWeight: "bold",
                                      fontSize: "10px",
                                    }}
                                    className={classes.psubtitle}
                                  >
                                    {order.modifiedAt.slice(8, 10)}.
                                    {order.modifiedAt.slice(5, 7)}.
                                    {order.modifiedAt.slice(0, 4)}{" "}
                                    {order.modifiedAt.slice(11, 16)}
                                    {order.modifiedAt.slice(16, 19)}
                                  </span>
                                </Grid>
                              </Grid>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                overflow: "hidden",
                                flexDirection: "row",
                                flexWrap: "nowrap",
                              }}
                            >
                              <div style={{ width: "66.66%" }}>
                                <p className={classes.pvalue}>
                                  &#x20B9;
                                  {/* {Math.round(
                                (order.atCost + Number.EPSILON) * 100
                              ) / 100} */}
                                  {order.total}
                                </p>
                              </div>
                              <div style={{ width: "66.66%" }}>
                                <p
                                  style={{ textAlign: "center" }}
                                  className={classes.pvalue}
                                >
                                  {/* {order.symbol.slice(0, 3) === "BTC"
                                ? Math.round(order.atIndexPrice)
                                : Math.round(
                                    (order.atIndexPrice + Number.EPSILON) * 100
                                  ) / 100} */}
                                  {order.pbRate}
                                </p>
                              </div>
                              <Grid container justify="flex-end">
                                <Grid item>
                                  <p className={classes.pvalue}>
                                    {order.quantity}
                                  </p>
                                </Grid>
                              </Grid>
                            </div>
                          </div>
                        ) : null,
                      )}
                    {orders.length >= 20 ? (
                      tradeHistory.last ? null : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                          }}
                        >
                          <Button
                            onClick={loadMore}
                            variant="outlined"
                            color="primary"
                            style={{ fontWeight: "bold" }}
                          >
                            Load more
                          </Button>
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ fontWeight: "bold" }}
                            onClick={() => {
                              history.push(`/transactions`);
                            }}
                          >
                            View all
                          </Button>
                        </div>
                      )
                    ) : null}
                  </div>
                </>
              )
            ) : (
              <div style={{ textAlign: "center" }}>
                {/* <CircularProgress
                  color="primary"
                  style={{ marginLeft: "10%", marginRight: "10%" }}
                /> */}
                <img
                  src={loaderGif}
                  alt="loading..."
                  style={{
                    marginTop: "10%",
                    marginBottom: "10%",
                    width: "180px",
                    height: "auto",
                  }}
                />
              </div>
            )}
          </>
        ) : (
          <Grid
            container
            justify="center"
            direction="column"
            alignItems="center"
            style={{ minHeight: "300px" }}
          >
            <Button
              onClick={() => {
                history.push(`/login`);
              }}
              variant="contained"
              color="primary"
              className={classes.login}
              style={{ fontWeight: "bold" }}
            >
              Login
            </Button>
            <p style={{ marginTop: "15px", marginBottom: "15px" }}>OR</p>
            <Button
              onClick={() => {
                history.push(`/createacc`);
              }}
              variant="outlined"
              color="primary"
              className={classes.create}
              style={{ fontWeight: "bold" }}
            >
              Create an account
            </Button>
          </Grid>
        )}
      </TabPanel>

      <TabPanel value={value} index={1} className={classes.customTabContainer}>
        {pendingOrders.length === 0 ? (
          <p
            style={{
              fontSize: "14px",
              color: theme.palette.type === "dark" ? "#C6C6CA" : "#808080",
              fontWeight: "bold",
              paddingTop: "15px",
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingBottom: "15px",
            }}
          >
            Your pending Pro trade orders will appear here.
          </p>
        ) : (
          <div className={classes.ptitleContainer}>
            <div style={{ width: "66.66%" }}>
              <p className={classes.ptitle}>Total</p>
            </div>
            <div style={{ width: "66.66%" }}>
              <p className={classes.ptitle} style={{ textAlign: "center" }}>
                Price
              </p>
            </div>
            <Grid container justify="flex-end">
              <Grid item>
                <p className={classes.ptitle} style={{ textAlign: "right" }}>
                  Quantity
                </p>
              </Grid>
            </Grid>
          </div>
        )}
        <div style={{ maxHeight: "80vh", overflow: "scroll" }}>
          {pendingOrders
            .filter((order) =>
              !hideOtherTrades
                ? true
                : order.symbol.slice(0, -3) == filterTradesBy,
            )
            .map((order) =>
              order.status === "PENDING" ? (
                <div
                  key={order.orderId}
                  className={classes.listItemStyle}
                  style={
                    theme.palette.type === "dark"
                      ? {
                          background:
                            order.side === "BUY" ? "#204847" : "#4C323B",
                        }
                      : {
                          background:
                            order.side === "BUY" ? "#D2F5EB" : "#FCDFDF",
                        }
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      overflow: "hidden",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                    }}
                  >
                    <p
                      style={{
                        marginTop: 0,
                        color: order.side === "BUY" ? "#3AC4AB" : "#DE565E",
                        fontWeight: "bold",
                        width: "66.66%",
                      }}
                      className={classes.psubtitle}
                    >
                      {order.side === "BUY" ? "Buy" : "Sell"}
                    </p>
                    <div style={{ width: "66.66%" }}>
                      <p
                        className={classes.psubtitle}
                        style={{ textAlign: "center" }} //right
                      >
                        {order.symbol.slice(0, -3)}
                        <span className={classes.baseCoin}>/INR</span>
                      </p>
                    </div>
                    <Grid container justify="flex-end">
                      <Grid item>
                        <span
                          style={{
                            color:
                              theme.palette.type === "dark"
                                ? "#cdcdcd"
                                : "#707384",
                            fontWeight: "bold",
                            fontSize: "10px",
                          }}
                          className={classes.psubtitle}
                        >
                          {order.createdAt.slice(8, 10)}.
                          {order.createdAt.slice(5, 7)}.
                          {order.createdAt.slice(0, 4)}{" "}
                          {order.createdAt.slice(11, 16)}
                          {order.createdAt.slice(16, 19)}
                        </span>
                      </Grid>
                    </Grid>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      overflow: "hidden",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                    }}
                  >
                    <div style={{ width: "66.66%" }}>
                      <p className={classes.pvalue}>{order.total}</p>
                    </div>
                    <div style={{ width: "66.66%" }}>
                      <p
                        style={{ textAlign: "center" }}
                        className={classes.pvalue}
                      >
                        {/* {order.symbol.slice(0, 3) === "BTC"
                      ? Math.round(order.atIndexPrice)
                      : Math.round(
                          (order.atIndexPrice + Number.EPSILON) * 100
                        ) / 100} */}
                        {order.pbRate}
                      </p>
                    </div>
                    <Grid container justify="flex-end">
                      <Grid item>
                        <p className={classes.pvalue}>
                          {order.quantity} {order.symbol.slice(0, -3)}
                          <span className={classes.baseCoin}>/INR</span>
                        </p>
                      </Grid>
                    </Grid>
                  </div>

                  <Grid container justify="flex-end">
                    <Grid item>
                      <ColorButton
                        variant="contained"
                        onClick={() => {
                          setDoubleClick(true);
                          handleCancelOrder(order.orderId);
                        }}
                        disabled={doubleClick}
                      >
                        Cancel Order
                      </ColorButton>
                    </Grid>
                  </Grid>
                </div>
              ) : null,
            )}
          {pendingOrders.length >= 20 && pendingHistory ? (
            pendingHistory.last ? null : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                }}
              >
                <Button
                  onClick={loadMorePending}
                  variant="outlined"
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  Load more
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ fontWeight: "bold" }}
                  onClick={() => {
                    history.push(`/transactions`);
                  }}
                >
                  View all
                </Button>
              </div>
            )
          ) : null}
        </div>
      </TabPanel>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
  },
  // customTab: {
  //   minWidth: "50%"
  // },
  customIndicator: {
    height: "7px",
  },
  appBar: {
    marginTop: "0px", //10px
    borderTopLeftRadius: "30px !important",
    borderTopRightRadius: "30px !important",
    boxShadow: "none",
    // borderBottom: "none !important",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",

    "& > div": {
      maxWidth: 20,
      width: "100%",
      backgroundColor: theme.palette.secondary.main,
    },
  },
  customTabContainer: {
    backgroundColor: theme.palette.type === "dark" ? "#151827" : "white",
    "& > div": {
      padding: 0,
    },
    borderBottomLeftRadius: "25px",
    borderBottomRightRadius: "25px",

    [theme.breakpoints.down("sm")]: {
      maxHeight: "100vh",
      overflow: "scroll",
    },
    // paddingTop: "15px",
    // paddingLeft: "20px",
    // paddingRight: "20px",
    // paddingBottom: "15px",
    // height: '60%'
    // minHeight: '300px',
  },
  ptitleContainer: {
    width: "100%",
    display: "flex",
    overflow: "hidden",
    flexDirection: "row",
    flexWrap: "nowrap",
    paddingLeft: "20px",
    paddingRight: "20px",
    [theme.breakpoints.up("xl")]: {
      paddingTop: "6px", //15px
      paddingBottom: "6px", //15px
    },
    [theme.breakpoints.down("lg")]: {
      paddingTop: "5px", //8px
      paddingBottom: "5px", //8px
    },
  },
  ptitle: {
    margin: 0,
    color: "#A7A8AF",
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "13px",
    },
    fontWeight: "bold",
  },
  psubtitle: {
    [theme.breakpoints.up("xl")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px",
    },
  },
  pvalue: {
    margin: 0,
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "13px",
    },
    fontWeight: "bold",
  },
  login: {
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "80%",
    },
    color: "white",
  },
  create: {
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "80%",
    },
  },
  "@global": {
    "*::-webkit-scrollbar": {
      width: "0px",
      background: "transparent",
      display: "none",
    },
  },
  baseCoin: {
    fontSize: "10px",
    color: theme.palette.type === "dark" ? "#cdcdcd" : "#707384",
  },
  listItemStyle: {
    width: "100%",
    paddingTop: "4px", //15px
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "4px", //15px
    fontSize: "13px",
  },
  styledAlert: {
    "& .MuiAlert-icon": {
      fontSize: 50,
      fontWeight: "bold",
    },
    fontSize: 15,
    fontWeight: "bold",
  },
}));

const CustomTabs = withStyles((theme) => ({
  root: {
    borderTopLeftRadius: "25px",
    borderTopRightRadius: "25px",
    boxShadow: "none !important",
    backgroundColor: theme.palette.type === "dark" ? "#2D2F3E" : "white",
    borderBottomStyle: theme.palette.type === "dark" ? null : "solid",
    borderColor: "#C0C1C5",
    borderWidth: "1px",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 3.5,
    "& > div": {
      width: "60%",
      borderRadius: "25px",
      backgroundColor: theme.palette.primary.main,
    },
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    color: "primary",
    fontWeight: "bold",
    fontSize: "11px",
    minWidth: "50%",
  },
  selected: { color: theme.palette.secondary.main },
}))((props) => <Tab {...props} />);

const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    fontWeight: "bold",
    backgroundColor: "#E65661",
    "&:hover": {
      backgroundColor: "#9b1722",
    },
    fontSize: "10px", //12px
    padding: "5px 5px", //4px 8px
  },
}))(Button);
